module.exports = function() {
  return new Worker("./" + "babel-transpiler.cdeea9e4.worker.js");
};